import { render, staticRenderFns } from "./ResultAssesment.vue?vue&type=template&id=3d7127b6"
import script from "./ResultAssesment.vue?vue&type=script&lang=js"
export * from "./ResultAssesment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports